/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';

export class EmailImportSettingsModel extends JSONable {
  host: string | null = null;
  port: number | null = null;
  emailFolderName: string | null = null;
  secureProtocol: boolean | null = null;
  userName: string | null = null;
  password: string | null = null;

  constructor() {
    super();
    this.host = null;
    this.port = 993;
    this.emailFolderName = 'INBOX';
    this.secureProtocol = false;
    this.userName = null;
    this.password = null;
  }
}
